const UTM_PARAMS = ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term']

export const UTM_HISTORY_KEY = 'silq_utm_history'
export const UTM_PENDING_KEY = 'silq_utm_pending'
export const UTM_SESSION_SYNCED_KEY = 'silq_utm_session_synced'

export type UTMHistory = Record<string, string[]>

export function buildUTMKey(searchParams: URLSearchParams): string | null {
  const parts: string[] = []
  for (const param of UTM_PARAMS) {
    const val = searchParams.get(param)
    if (val) parts.push(`${param}=${val}`)
  }
  return parts.length > 0 ? parts.join('&') : null
}

function readFromStorage(key: string): UTMHistory {
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function writeToStorage(key: string, data: UTMHistory): void {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch {}
}

export function readUTMPending(): UTMHistory {
  return readFromStorage(UTM_PENDING_KEY)
}

export function recordAnonymousUTM(key: string, timestamp: string): void {
  const history = readFromStorage(UTM_HISTORY_KEY)
  const pending = readFromStorage(UTM_PENDING_KEY)
  const updatedHistory = { ...history, [key]: [...(history[key] ?? []), timestamp] }
  const updatedPending = { ...pending, [key]: [...(pending[key] ?? []), timestamp] }
  writeToStorage(UTM_HISTORY_KEY, updatedHistory)
  writeToStorage(UTM_PENDING_KEY, updatedPending)
}

export function recordAuthenticatedUTM(key: string, timestamp: string): void {
  const history = readFromStorage(UTM_HISTORY_KEY)
  const updated = { ...history, [key]: [...(history[key] ?? []), timestamp] }
  writeToStorage(UTM_HISTORY_KEY, updated)
}

export function clearUTMPending(): void {
  try { localStorage.removeItem(UTM_PENDING_KEY) } catch {}
}
